<!-- Sin caja ni encabezado propios: esto es el CONTENIDO de una pestaña de la columna derecha, y el
     título lo pone la pestaña. Tenerlos aquí era el defecto — usaba las clases de tarjeta del
     detalle, que no le alcanzan, y salía sin caja y con el título gritando. -->
<section class="wl-trace" *ngIf="trace">
  <!-- Lo ÚNICO que scrollea son los pasos. -->
  <div class="wl-trace-body">
    <p class="wl-trace-note" *ngIf="trace.truncated">
      <i class="fa-solid fa-scissors"></i>
      Se omitieron {{ trace.droppedCount }} pasos anteriores por tamaño.
    </p>

    <ol class="wl-trace-list">
      <li *ngFor="let e of trace.events; let i = index" [class.is-failure]="isFailure(e)">
        <span class="wl-trace-when">{{ relative(e) }}</span>
        <span class="wl-trace-icon" [style.color]="meta(e.kind).color"><i [class]="meta(e.kind).icon"></i></span>
        <div class="wl-trace-main">
          <span class="wl-trace-label">{{ e.label }}</span>
          <button type="button" class="wl-trace-toggle" *ngIf="hasPayload(e)" (click)="togglePayload(i)">
            {{ openPayloads.has(i) ? 'ocultar detalle' : 'ver detalle' }}
          </button>
          <pre class="wl-trace-payload" *ngIf="openPayloads.has(i)">{{ payloadOf(e) }}</pre>
        </div>
      </li>
    </ol>
  </div>

  <!-- El pie queda anclado abajo, fuera del scroll. El navegador, la versión y la pantalla son el
       contexto contra el que se leen TODOS los pasos, no un dato más al final de la lista: con 60
       filas quedaban a un scroll de distancia justo cuando hacían falta. La misma razón por la que
       la caja de comentario de la otra pestaña vive anclada — y por eso comparten tratamiento. -->
  <footer class="wl-trace-foot">
    <div class="wl-trace-env">
      <span>{{ trace.context.userAgent }}</span>
      <span>App {{ trace.context.appVersion }} · Ventana {{ trace.context.viewport.width }}×{{ trace.context.viewport.height }}</span>
      <span *ngIf="trace.context.url" class="wl-trace-url">{{ trace.context.url }}</span>
    </div>

    <!-- Cuando el servidor recortó los detalles, se dice. Un hueco sin explicación hace pensar que
         la bitácora está incompleta, cuando en realidad es una restricción de permisos. -->
    <p class="wl-trace-note" *ngIf="!trace.full">
      <i class="fa-solid fa-lock"></i>
      Los datos de cada petición se muestran solo al equipo de desarrollo y a quien reportó.
    </p>

    <button type="button" class="wl-trace-download" *ngIf="trace.full" (click)="download()">
      <i class="fa-solid fa-download"></i> Descargar los pasos en JSON
    </button>
  </footer>
</section>
